import { HolderTableTradeCell } from './holder-table-trade-cell'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type HolderTableBoughtCellProps = {
  buyVolumeInUsd: BigNumber
  buyVolumeInToken: BigNumber
  buys: number
} & ClassNameProps

export const HolderTableBoughtCell = (props: HolderTableBoughtCellProps) => {
  return (
    <HolderTableTradeCell
      color={'green'}
      volumeInUsd={props.buyVolumeInUsd}
      volumeInToken={props.buyVolumeInToken}
      number={props.buys}
    />
  )
}
